module.exports = __webpack_public_path__ + "static/media/login_bg.ad2b4ecf.png";